import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { catchError, Observable, switchMap, throwError } from 'rxjs';

import { environment } from '../../environments/environment';
import { MpsOauth2Provider } from '../models/mps-provider.model';
import { mpsEndpoints } from '../mps-endpoints';
import { mpsRouteNames } from '../mps-route-names';
import { MpsOauth2Service } from '../services/mps-oauth2.service';

@Injectable()
export class MpsUnauthenticatedInterceptor implements HttpInterceptor {
  private oauth2Service = inject(MpsOauth2Service);
  private router = inject(Router);

  intercept(req: HttpRequest<unknown>, handler: HttpHandler): Observable<HttpEvent<unknown>> {
    return handler.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 && req.url !== environment.api.host + '/' + mpsEndpoints.user) {
          const provider = localStorage.getItem('provider');

          if (provider) {
            return this.refreshToken(provider, req, handler);
          } else {
            this.getProviders();
          }
        }

        return throwError(() => error);
      })
    );
  }

  private refreshToken(provider: string, req: HttpRequest<unknown>, handler: HttpHandler) {
    return this.oauth2Service.refreshToken(provider).pipe(
      switchMap((response) => {
        localStorage.setItem('token', response.token);

        // Retry the request
        return this.retryRequest(req, response, handler);
      }),
      catchError((error: HttpErrorResponse) => {
        this.getProviders();
        return throwError(() => error);
      })
    );
  }

  private retryRequest(
    req: HttpRequest<unknown>,
    response: { token: string },
    handler: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const clonedRequest = req.clone({
      setHeaders: {
        Authorization: `Bearer ${response.token}`,
      },
    });

    return handler.handle(clonedRequest).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.getProviders();
        }

        return throwError(() => error);
      })
    );
  }

  private getProviders(): void {
    this.oauth2Service.getProviders().subscribe((providers: MpsOauth2Provider[]) => {
      if (providers.length === 1) {
        localStorage.setItem('provider', providers[0].code);
        window.location.href = providers[0].url;
      } else {
        this.router.navigateByUrl(mpsRouteNames.auth + '/' + mpsRouteNames.login);
      }
    });
  }
}
